import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Field, RadioGroup, Radio } from '@availity/form';
import '@availity/yup';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import housingStore from '../stores/housingstore';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import withNavigate from '../../Common/components/withNavigate';

@observer
class AHAHRap extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirectToTransportation: false,
      redirectToSignatures: false,
      redirectToLandingPage: false,
    }

    if(window.performance) {
			if(performance.navigation.type == 1) {
        housingStore.resetSupportiveHousingPage();
				window.location.href = '#';
			}
		}
  }

  componentWillMount() {
    const { memberInfo } = housingStore;
    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;
    
    if (housingStore.getSupportiveHousingRouteStatus('/transportationinformation') !== 'completed') {
      housingStore.resetSupportiveHousingPage();
      housingStore.resetSupportiveHousingRoutesStatus();
      this.setState({ redirectToLandingPage: true });
    } else if (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes') {
      if (housingStore.getSupportiveHousingRouteStatus('/ahah-rap') !== 'active') {
        housingStore.setSupportiveHousingPageStatus('#ahah-rap', 'active');
        housingStore.setSupportiveHousingRouteStatus('/ahah-rap', 'active');
      }
    }
  }

  componentDidMount() {
    const {memberInfo} = housingStore;
    const {isHomeless, isEnrolleeEligibleForAHAH} = memberInfo;
    window.onpopstate = () => {
      this.props.navigate(1);
    }
    setTimeout(() => {
      if (isHomeless !== 'Yes' || isEnrolleeEligibleForAHAH !== 'Yes') {
        this.props.navigate('/');
      }
    }, 0);
  }

  setChronicRadio = value => {
    housingStore.setAHAHChronicRadio(value);
  }

  setChronicFirstLast = event => {
    const { value } = event.target;
    housingStore.setAHAHChronicFirstLast(value);
  }

  setFreqResStayRadio = value => {
    housingStore.setAHAHFreqResRadio(value);
  }

  setFreqResStayFirstLast = event => {
    const { value } = event.target;
    housingStore.setAHAHFreqResFirstLast(value);
  }

  setLenghtyRadio = value => {
    housingStore.setAHAHLengthRadio(value);
  }

  setLenghtyFirstLast = event => {
    const{ value } = event.target;
    housingStore.setAHAHLengthFirstLast(value);
  }

  goBack = () => {
    housingStore.setSupportiveHousingPageStatus('#housingassessment', 'active');
    housingStore.setSupportiveHousingPageStatus('#ahah-rap', 'disabled');
    housingStore.setSupportiveHousingRouteStatus('/transportationinformation', 'active');
    housingStore.setSupportiveHousingRouteStatus('/ahah-rap', 'inactive');
    this.setState({ redirectToTransportation: true });
  }

  submit = (pendingRoute = '/signature') => {
    housingStore.setSupportiveHousingPageStatus('#ahah-rap', 'active');
    housingStore.setSupportiveHousingRouteStatus('/ahah-rap', 'completed');
    if (pendingRoute === '/signature') {
      this.setState({ redirectToSignatures: true });
      return;
    }
    this.props.navigate(pendingRoute);
  }

  render() {
    const { redirectToTransportation, redirectToSignatures, redirectToLanding } = this.state;

    const { 
      supportiveHousingPagesAHAH,
      ahahChronicHomelessness,
      ahahFreqResCareStay,
      ahahLengthyInstContacts,
    } = housingStore;

    const {
      ahahChronicRadio,
      ahahChronicFirstLast,
    } = ahahChronicHomelessness;

    const {
      ahahFreqResRadio,
      ahahFreqResStayFirstLast
    } = ahahFreqResCareStay;

    const {
      ahahLengthyRadio,
      ahahLengthyFirstLast
    } = ahahLengthyInstContacts;

    if(redirectToTransportation) {
      return <Navigate to="/transportationinformation" />
    }

    if(redirectToSignatures) {
      return <Navigate to="/signature" />
    }

    if(redirectToLanding) {
      return <Navigate to="/" />
    }

    return (
      <>
        <div className='border-form'>
          <div className='spacer-50' />

          <ProgressValidatedForm
            pages={supportiveHousingPagesAHAH}
            enableReinitialize
            initialValues={{
              chHomelessRadio: ahahChronicRadio,
              chFirstLast: ahahChronicFirstLast,
              freqResRadio: ahahFreqResRadio,
              freqResFirstLast: ahahFreqResStayFirstLast,
              lengthyRadio: ahahLengthyRadio,
              lengthyFirstLast: ahahLengthyFirstLast
            }}
            onSubmit={this.submit}
            validationSchema={yup.object().shape({
              chHomelessRadio: yup.string().required('Please select an option before continuing!'),
              chFirstLast: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'First and Last Name should be alpha-numeric')
                .isRequired(ahahChronicRadio === 'Yes','First and Last Name is required'),
              freqResRadio: yup.string().required('Please select an option before continuing!'),
              freqResFirstLast: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'First and Last Name should be alpha-numeric')
                .isRequired(ahahFreqResRadio === 'Yes','First and Last Name is required'),
              lengthyRadio: yup.string().required('Please select an option before continuing!'),
              lengthyFirstLast: yup.string()
                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'First and Last Name should be alpha-numeric')
                .isRequired(ahahLengthyRadio === 'Yes','First and Last Name is required'),
            })}
          >
            <small className='required-fields'>*required fields</small>
            <div className='spacer' />
            <h2 className='poppinsH2'>
              Apple Health and Homes Rental Assistance Program (AHAH-RAP)
              <br />Drawing Information
            </h2>
            <em>
              <small className='label-font lh-24'>
                The following information will be used via self-reporting
                for the AHAH Rental Assistance Program drawing entries.
              </small>
            </em>

            <div className='spacer' />

            <div className='d-flex'>
              <h5 className='poppinsH5'>
                Chronic homelessness:*
              </h5>
            </div>
            <div>
              <UncontrolledTooltip target='chHomelessTip' placement='top'>
                <div className='left-text'>
                  <div>
                    A homeless person with a long-continuing or 
                    indefinite physical condition requiring
                    improvement, stabilization, or prevention of 
                    deterioration of functioning, including the ability to
                    live independently without support; and have at
                    least one of the following risk factors: 
                  </div>

                  <div className='spacer-16'>
                    1. Be a homeless person at the time of the eligibility
                    determination for the program and have been 
                    homeless for 12 months prior to the eligibility
                    determination; or
                  </div>
                  <div className='spacer-5'>
                    2. Have been a homeless person on at least four
                    separate occasions in the three years prior to the
                    eligibility determination for the program, as long as
                    the combined occasions equal at least 12 months
                  </div>
                </div>
              </UncontrolledTooltip>
              <p className='label-font mr-5'>
                Does the Enrollee meet the <span id='chHomelessTip' className='ahah-link'>AHAH definition of chronically homeless</span>?*
              </p>

              <div className='spacer-12' />

              <div>
                <RadioGroup value={ahahChronicRadio} inline name="chHomelessRadio" onChange={this.setChronicRadio}>
                  <Radio className="label-font-round" name="chHomelessOption" label="Yes" value="Yes" />
                  <Radio className="label-font-round" name="chHomelessOption" label="No" value="No" />
                </RadioGroup>
              </div>

              <p className='label-font'>
                <span>
                If yes, please provide your first and last name to confirm that you attest to the below.
                </span>
                <div className='d-flex align-items-end'>
                  <span className='mr-4'>I,</span>
                  <Field
                    type="text"
                    id="chFirstLast"
                    name='chFirstLast'
                    value={ahahChronicFirstLast}
                    className='center-text'
                    onChange={this.setChronicFirstLast}
                    disabled={ahahChronicRadio.length === 0 || ahahChronicRadio === 'No'}
                    maxLength={50}
                    aria-label='First and last name of the person attesting to being chronically homeless'
                  />
                    ,&nbsp;have experienced being homeless for the last 12 months in which I lived in a place not meant for 
                    human
                </div>
                <div>
                  habitation, in a safe haven, or in an emergency shelter or on at least for separate occasions
                  in the last three years.  I was homeless for a total of at least 12 months.
                </div>
              </p>
            </div>

            <div className='spacer' />

            <div className='d-flex'>
              <h5 className='poppinsH5'>
                Frequent residential care stays:*
              </h5>
            </div>
            <div>
              <UncontrolledTooltip target='freqResStayTip' placement='top'>
                <div className='left-text'>
                  Frequent as in two or more occurrences in 
                  the past 12 months. History of frequent or 
                  lengthy adult residential care facilities as 
                  defined by <u>WAC 388-110-020</u>, or
                  residential treatment facilities as defined 
                  <br />by <u>WAC 246-337-005</u>.
                </div>
              </UncontrolledTooltip>
              <p className='label-font mr-5'>
                Does the Enrollee have <span id='freqResStayTip' className='ahah-link'>frequent residential care stays</span><span> </span>
                (two or more occurrences in the past 12 months)?*
              </p>

              <div className='spacer-12' />

              <div>
                <RadioGroup value={ahahFreqResRadio} inline name="freqResRadio" onChange={this.setFreqResStayRadio}>
                  <Radio className="label-font-round" name="freqResRadioOption" label="Yes" value="Yes" />
                  <Radio className="label-font-round" name="freqResRadioOption" label="No" value="No" />
                </RadioGroup>
              </div>
              
              <p className='label-font'>
                <span>
                  If yes,  please provide your first and last name to confirm that you attest the below.
                </span>
                <div className='d-flex align-items-end'>
                  <span className='mr-4'>I,</span>
                  <Field
                    type="text"
                    id="freqResFirstLast"
                    name='freqResFirstLast'
                    value={ahahFreqResStayFirstLast}
                    className='center-text'
                    onChange={this.setFreqResStayFirstLast}
                    disabled={ahahFreqResRadio.length === 0 || ahahFreqResRadio === 'No'}
                    maxLength={50}
                    aria-label='First and last name of the person attesting to frequent residential care stays'
                  />
                    ,&nbsp;have experienced frequent residential care stays as defined above.
                </div>
              </p>
            </div>

            <div className='spacer' />

            <div className='d-flex'>
              <h5 className='poppinsH5'>
                Frequent or lengthy institutional contacts:*
              </h5>
            </div>
            <div>
              <UncontrolledTooltip target='lengthyTip' placement='top'>
                <div className='left-text'>
                  Frequent as in two or more instances in the 
                  past 12 months or 90 days or greater.
                  Includes jails, substance use disorder or 
                  mental health treatment facilities, hospitals, or 
                  other similar facilities, as defined in 24 C.F.R. 
                  578.3, or skilled nursing facilities as defined 
                  <br />in <u>WAC 388-97-0001</u>.
                </div>
              </UncontrolledTooltip>
              <p className='label-font mr-5'>
                Does the Enrollee have <span id='lengthyTip' className='ahah-link'>frequent or lengthy institutional contacts</span><span> </span>
                (two or more instances in the past 12 months or 90 days or greater)?*
              </p>

              <div className='spacer-12' />

              <div>
                <RadioGroup value={ahahLengthyRadio} inline name="lengthyRadio" onChange={this.setLenghtyRadio}>
                  <Radio className="label-font-round" name="lengthyRadioOption" label="Yes" value="Yes" />
                  <Radio className="label-font-round" name="lengthyRadioOption" label="No" value="No" />
                </RadioGroup>
              </div>

              <p className='label-font'>
                <span>
                If yes, please provide your first and last name to confirm that you attest to the below.
                </span>
                <div className='d-flex align-items-end'>
                  <span className='mr-4'>I,</span>
                  <Field
                    type="text"
                    id="lengthyFirstLast"
                    name='lengthyFirstLast'
                    value={ahahLengthyFirstLast}
                    className='center-text'
                    onChange={this.setLenghtyFirstLast}
                    disabled={ahahLengthyRadio.length === 0 || ahahLengthyRadio === 'No'}
                    maxLength={50}
                    aria-label='First and last name of the person attesting to frequent or lengthy institutional contacts'
                  />
                    ,&nbsp;have experienced frequent or lengthy institutional contacts as defined above.
                </div>
              </p>
            </div>
            
            <div className='spacer-64' />
            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
            </Button>
            <Button type="submit" color={"primary"} className={'btn btn-primary nextBtn'}>
              Next
            </Button>
          </ProgressValidatedForm>
        </div>
        <div className='pb-spacerRem-4' />
      </>
    )

  }
}

export default withNavigate(AHAHRap);

AHAHRap.propTypes = {
  navigate: PropTypes.func
};